/* Gerber product tabs: accessible tablist (click, arrow keys, Home/End) plus theme-editor block selection. */
(() => {
  document.querySelectorAll('[data-gpt]').forEach(root => {
    if (root.dataset.gptReady) return;
    root.dataset.gptReady = '1';
    const tabs = [...root.querySelectorAll('.gpt__tab')];
    const panels = [...root.querySelectorAll('.gpt__panel')];

    const select = (index, focus) => {
      tabs.forEach((tab, i) => {
        const on = i === index;
        tab.setAttribute('aria-selected', on ? 'true' : 'false');
        tab.tabIndex = on ? 0 : -1;
        if (panels[i]) panels[i].hidden = !on;
      });
      if (focus) tabs[index].focus();
      tabs[index].scrollIntoView({ block: 'nearest', inline: 'nearest' });
    };

    tabs.forEach((tab, i) => {
      tab.addEventListener('click', () => select(i, false));
      tab.addEventListener('keydown', e => {
        const last = tabs.length - 1;
        const keys = {
          ArrowRight: i === last ? 0 : i + 1,
          ArrowLeft: i === 0 ? last : i - 1,
          Home: 0,
          End: last
        };
        if (e.key in keys) {
          e.preventDefault();
          select(keys[e.key], true);
        }
      });
    });

    // Theme editor: selecting a tab block in the sidebar shows that tab
    root.addEventListener('shopify:block:select', e => {
      const i = tabs.indexOf(e.target.closest('.gpt__tab'));
      if (i >= 0) select(i, false);
    });
    tabs.forEach((tab, i) => tab.addEventListener('shopify:block:select', () => select(i, false)));
  });
})();
